import {ReactNode} from "react";

interface OperatorsListProps {
    title: string | ReactNode,
    operators: string[]
}

function OperatorsList({title, operators}: OperatorsListProps) {
    return (
        <>
            <h2>
                {title}
            </h2>
            <ul>
                {operators.map((operator) => (
                    <li key={operator}>
                        {operator}
                    </li>
                ))}
            </ul>
        </>
    )
}

export default OperatorsList